module.exports = __webpack_public_path__ + "img/vip.d767fa7f.png";